import React, {useState, useEffect, useRef, useMemo} from "react";
import { Container, Heading, InvalidMode, FormBody } from "./Elements";
import { FormInput, FormLabel, SelectInput } from "../../ui-elements/Input";
import { PrimaryButton } from "../../ui-elements/Button";
import { Circles } from "react-loader-spinner";
import { toast } from "react-toastify";
import { CirclesWithBar } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// importing actions
import {
  singleImageUploadStart,
  singleImageUploadStateReset,
} from "../../store/ImageUpload/actions";
import { createUserStart, updateUserStart } from "../../store/User/actions";
import { getBuildingListStart } from "../../store/Building/actions";
import CleanerBuildingAssignments from "../CleanerBuildingAssignments/CleanerBuildingAssignments";

const UserForm = ({ mode }) => {
  const dispatch = useDispatch();
  const imageUpload = useSelector((state) => state.imageUpload);
  const buildingState = useSelector((state) => state.buildings);
  const { selected_project } = useSelector((state) => state.project);
  const selectedProject = useMemo(() => selected_project, [selected_project]);
  const { singleUploadedImage, singleImageUpdateError, uploadingSingleImage } =
    imageUpload;
  const user = useSelector((state) => state.user);
  const staffUser = useSelector(state => state.Auth.staffUser);
  const navigate = useNavigate();
  const {
    newUser,
    createUserError,
    creatingNewUser,
    userUpdateState,
    userUpdateError,
  } = user;
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    profile_picture: "",
    type: "customer",
    password: "",
    confirm_password: "",
    assignedBuildingIds: [],
    skills: [],
  });
  const [skillsInput, setSkillsInput] = useState("");
  const [countryCode, setCountryCode] = useState(
    process.env.REACT_APP_DEFAULT_COUNTRY_CODE
  );
  const [selectedImage, setSelectedImage] = useState(null);
  function userFormSubmitHandler(e) {
    const payload = {
      ...formData,
      phone: `${countryCode}-${formData.phone}`,
      projectId: selectedProject?.id,
      assignedBuildingIds:
        mode === "edit" &&
        (formData.type === "technician" || formData.type === "cleaner")
          ? formData.assignedBuildingIds
          : undefined,
      skills:
        mode === "edit" && formData.type === "technician"
          ? formData.skills
          : undefined,
    };

    // if (mode === "edit" && formData.type === "technician" && payload.skills?.length === 0) {
    //   toast.error("Technician users must have at least one skill.");
    //   return;
    // }
    // if (
    //   mode === "edit" &&
    //   (formData.type === "technician" || formData.type === "cleaner") &&
    //   payload.assignedBuildingIds?.length === 0
    // ) {
    //   toast.error("Assigned Buildings is required for technician and cleaner roles.");
    //   return;
    // }

    if (mode === "create") {
      if (formData.type === "customer") payload.is_primary = 1;
      dispatch(createUserStart(payload));
    } else {
      payload.id = user?.userToUpdate?.id;
      dispatch(updateUserStart(payload));
    }
  }
  useEffect(() => {
    if (newUser) {
      if (window.location.pathname.includes("users")) {
        navigate(`/users/${newUser.response.dataValues.id}`, { return: true });
      }
    }
  }, [newUser]);

  useEffect(() => {
    if (selectedProject?.id) {
      dispatch(
        getBuildingListStart({
          projectId: selectedProject?.id,
        })
      );
    }
  }, [selectedProject, dispatch]);

  useEffect(() => {
    if (user?.userToUpdate) {
      setFormData({
        name: user?.userToUpdate?.name || "",
        phone: user?.userToUpdate?.phone || "",
        email: user?.userToUpdate?.email || "",
        profile_picture: user?.userToUpdate?.profile_picture || "",
        type: user?.userToUpdate?.type || "customer",
        password: user?.userToUpdate?.password || "",
        confirm_password: "",
        assignedBuildingIds: user?.userToUpdate?.assignedBuildingIds || [],
        skills: user?.userToUpdate?.skills || [],
      });
    } else {
      setFormData({
        name: "",
        phone: "",
        email: "",
        profile_picture: "",
        type: "customer",
        password: "",
        confirm_password: "",
        assignedBuildingIds: [],
        skills: [],
      });
      setSkillsInput("");
    }
  }, [user?.userToUpdate]);
  useEffect(() => {
    if (createUserError) {
      if (Array.isArray(createUserError?.response)) {
        const errorList = createUserError?.response;
        errorList.forEach((error) => {
          const keys = Object.keys(error);
          keys.forEach((key) => {
            toast.error(error[key]);
          });
        });
        if (createUserError?.response?.length === 0) {
          toast.error(createUserError?.message);
        }
      } else {
        toast.error(JSON.stringify(createUserError));
      }
    }
  }, [createUserError]);
  useEffect(() => {
    if (userUpdateError) {
      if (Array.isArray(userUpdateError?.response)) {
        user?.userUpdateError?.response?.forEach((err) => {
          const keys = Object.keys(err);
          keys.forEach((key) => {
            toast.error(`${key} : ${err[key]}`);
          });
        });
      }
    }
  }, [userUpdateError]);
  useEffect(() => {
    if (user?.userUpdate) {
      toast.success("User updated successfully");
    }
  }, [user?.userUpdate]);

  useEffect(() => {
    if (singleUploadedImage) {
      // toast.success("Image Uploaded successfully");
      setFormData({
        ...formData,
        profile_picture: singleUploadedImage?.response?.files[0]?.path,
      });
    }
  }, [singleUploadedImage]);

  if (mode !== "create" && mode !== "edit")
    return <InvalidMode>Invalid mode for User Form</InvalidMode>;
  return (
    <Container>
      <Heading>{mode === "create" && `Register New User`}</Heading>
      <FormBody>
        <FormLabel>Full Name*</FormLabel>
        <FormInput
          width="500px"
          disabled={uploadingSingleImage}
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
        {mode === "create" && <hr />}
        {mode === "create" && <FormLabel>Phone Number*</FormLabel>}
        {mode === "create" && (
          <div
            style={{ display : 'flex' , alignItems : 'center' , gap : 5 }}
          >
            <FormInput
                width={"80px"}
                disabled={uploadingSingleImage}
                value={countryCode}
                onChange={e=> setCountryCode(e.target.value)}
            />

            <FormInput
                width="400px"
                disabled={uploadingSingleImage}
                value={formData.phone}
                onChange={(e) =>
                    setFormData({ ...formData, phone: e.target.value })
                }
                type='text'
            />
          </div>
        )}
        <hr />
        <FormLabel>Email</FormLabel>
        <FormInput
          width="500px"
          disabled={uploadingSingleImage}
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
        <hr />
        <FormLabel>Proflie Picture</FormLabel>
        {formData?.profile_picture && (
          <>
            <img
              style={{
                height: "400px",
                width: "400px",
                objectFit: "cover",
                borderRadius: "50%",
              }}
              src={
                formData?.profile_picture?.includes("http")
                  ? formData?.profile_picture
                  : process.env.REACT_APP_IMAGE_BASE_PATH +
                    formData?.profile_picture
              }
            />
            <br />
          </>
        )}
        {uploadingSingleImage && (
          <>
            <Circles width={30} /> <br />
          </>
        )}
        <FormInput
          type="file"
          width="500px"
          disabled={uploadingSingleImage}
          onChange={(e) => {
            if (e.target.files.length > 0) {
              setSelectedImage(e.target.files[0]);
              const multipartFormData = new FormData();
              multipartFormData.append("image", e.target.files[0]);
              dispatch(singleImageUploadStart(multipartFormData));
            }
          }}
          accept="image/*"
        />
        <hr />

        {mode === "create" && (
          <>
            <FormLabel>Type of User*</FormLabel>
            <SelectInput
              width="510px"
              disabled={uploadingSingleImage}
              value={formData.type}
              onChange={(e) =>
                setFormData({ ...formData, type: e.target.value })
              }
            >
              {window.location.pathname.includes("assign") ? (
                <option value="customer">Customer</option>
              ) : staffUser?.type === "admin" ? (
                <>
                  <option value="customer">Customer</option>
                  <option value="security">Security</option>
                  <option value="supervisor">Supervisor</option>
                  <option value="technician">Technician</option>
                  <option value="cleaner">Cleaner</option>
                  <option value="project_manager">Project Manager</option>
                  <option value="super_user">Super User</option>
                  <option value="sub_admin">Sub Admin</option>
                </>
              ) : (
                <>
                  <option value="customer">Customer</option>
                  <option value="security">Security</option>
                  <option value="supervisor">Supervisor</option>
                  <option value="technician">Technician</option>
                  <option value="cleaner">Cleaner</option>
                </>
              )}
            </SelectInput>
          </>
        )}
        {formData?.type !== "customer" && (
          <>
            {mode === "create" && <hr />}
            {mode === "create" && <FormLabel>Password*</FormLabel>}
            {mode === "create" && (
              <FormInput
                width="500px"
                disabled={uploadingSingleImage}
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
              />
            )}
            <p
              style={{
                color: "grey",
                padding: "5px",
                fontSize: "0.6em",
                width: "510px",
              }}
            >
              * Password must be of length between 8 and 20 characters,
              numbers and letters only,
              no spaces or other special characters allowed.
            </p>

            {/* {mode === "edit" && (formData.type === "technician" || formData.type === "cleaner") && (
              <>
                <hr />
                <FormLabel>Assigned Buildings*</FormLabel>
                <select
                  multiple
                  className="form_input"
                  style={{ width: "510px", minHeight: "100px" }}
                  value={formData.assignedBuildingIds}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      assignedBuildingIds: Array.from(
                        e.target.selectedOptions,
                        (option) => option.value
                      ),
                    })
                  }
                >
                  {buildingState?.buildings?.data?.map((building) => (
                    <option key={building.id} value={building.id}>
                      {building.building_number}
                    </option>
                  ))}
                </select>
                <p
                  style={{
                    color: "grey",
                    padding: "5px",
                    fontSize: "0.75em",
                    width: "510px",
                  }}
                >
                  Hold Ctrl / Cmd to select multiple buildings.
                </p>
              </>
            )} */}

            {/* {mode === "edit" && formData.type === "technician" && (
              <>
                <hr />
                <FormLabel>Skills*</FormLabel>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <FormInput
                    width="360px"
                    disabled={uploadingSingleImage}
                    value={skillsInput}
                    placeholder="Add a skill and press Enter"
                    onChange={(e) => setSkillsInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        const skill = skillsInput.trim();
                        if (skill && !formData.skills.includes(skill)) {
                          setFormData((prev) => ({
                            ...prev,
                            skills: [...prev.skills, skill],
                          }));
                        }
                        setSkillsInput("");
                      }
                    }}
                  />
                  <button
                    type="button"
                    style={{
                      padding: "10px 16px",
                      borderRadius: "6px",
                      border: "1px solid #0f4485",
                      backgroundColor: "#0f4485",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const skill = skillsInput.trim();
                      if (skill && !formData.skills.includes(skill)) {
                        setFormData((prev) => ({
                          ...prev,
                          skills: [...prev.skills, skill],
                        }));
                      }
                      setSkillsInput("");
                    }}
                  >
                    Add
                  </button>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 10, width: "510px" }}>
                  {formData.skills.map((skill, index) => (
                    <div
                      key={`${skill}_${index}`}
                      style={{
                        padding: "4px 10px",
                        borderRadius: "20px",
                        backgroundColor: "#f0f4ff",
                        border: "1px solid #dce5ff",
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <span>{skill}</span>
                      <button
                        type="button"
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            skills: prev.skills.filter((item) => item !== skill),
                          }))
                        }
                        style={{
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                          color: "#0f4485",
                          fontWeight: 700,
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
                <p
                  style={{
                    color: "grey",
                    padding: "5px",
                    fontSize: "0.75em",
                    width: "510px",
                  }}
                >
                  Use skills to help supervisors assign the right technician.
                </p>
              </>
            )} */}

            {mode === "edit" &&
              formData.type === "cleaner" &&
              staffUser?.type === "admin" && (
                <>
                  <hr />
                  <CleanerBuildingAssignments cleanerId={user?.userToUpdate?.id} />
                </>
              )}

            {mode === "create" && <hr />}
          </>
        )}
        <hr />
        {creatingNewUser || userUpdateState ? (
          <CirclesWithBar
            height={40}
            color={"blue"}
            style={{ margin: "0 auto", display: "block" }}
          />
        ) : (
          <PrimaryButton
            disabled={uploadingSingleImage}
            width="300px"
            onClick={userFormSubmitHandler}
          >
            {mode === "create" ? `Register` : "Update User"}
          </PrimaryButton>
        )}

        <hr />
      </FormBody>
    </Container>
  );
};

export default UserForm;
